import { Button } from '@/components/ui/button';
import React from 'react';

type VoucherPaginationProps = {
  currentPage: number;
  totalPages: number;
  totalVouchers: number;
  onPageChange: (page: number) => void;
  itemLabel?: string;
};

export const VoucherPagination: React.FC<VoucherPaginationProps> = ({
  currentPage,
  totalPages,
  totalVouchers,
  onPageChange,
  itemLabel = 'Gutscheine',
}) => {
  return (
    <div className='flex w-full items-center justify-between'>
      <div className='flex items-center gap-2'>
        <Button
          variant='outline'
          className='size-10 rounded-md p-0'
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ‹
        </Button>

        {(() => {
          const elements: React.ReactNode[] = [];
          const pageNumbers = [1, 2, 3];
          for (const n of pageNumbers) {
            if (n > totalPages) break;
            elements.push(
              <Button
                size='icon'
                key={n}
                variant={n === currentPage ? 'default' : 'outline'}
                className={n === currentPage ? 'size-10 rounded-md bg-[#006877] text-white' : 'size-10 rounded-md'}
                onClick={() => onPageChange(n)}
              >
                {n}
              </Button>
            );
          }
          if (totalPages > 4) {
            elements.push(
              <span key='ellipsis' className='px-2 text-muted-foreground'>
                …
              </span>
            );
          }
          if (totalPages >= 4) {
            elements.push(
              <Button
                size='icon'
                key={totalPages}
                variant={totalPages === currentPage ? 'default' : 'outline'}
                className={
                  totalPages === currentPage
                    ? 'size-10 max-w-fit rounded-md px-0! bg-[#006877] text-white'
                    : 'size-10 rounded-md'
                }
                onClick={() => onPageChange(totalPages)}
              >
                {totalPages}
              </Button>
            );
          }
          return elements;
        })()}

        <Button
          variant='outline'
          className='size-10 rounded-md p-0'
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          ›
        </Button>
      </div>

      <div className='text-sm text-muted-foreground'>
        Seite {currentPage} von {totalPages} ({totalVouchers} {itemLabel})
      </div>
    </div>
  );
};

export default VoucherPagination;
